<template>
	<SOSlotModal
		:modal-title="'Ubah Agama'"
		:modal-id="id"
		@close="close"
	>
		<template v-slot:modal-body>
			<SOInputSelect
				:title="'Agama'"
				:selected="(customer.agama === '' || customer.agama === null) ? '' : agama[agama.findIndex((a) => a.id === customer.agama )].id"
				:options="agama"
				:placeholder="'Pilih Agama'"
				@option-selected="getAgama"
			/>
			<div class="f-regular f-12 f-c-midgrey m-t-4">
				Untuk target promo: perayaan hari besar agama
			</div>
			<ErrorMessage
				v-if="pageSetting.btn.save.clicked"
				class="error"
				label="Agama"
				:validation="$v.customerTemp.agama"
			/>
		</template>
		<template v-slot:modal-footer>
			<SOButton
				:text="'Simpan'"
				:primary="true"
				:full="true"
				:disable="pageSetting.btn.save.disabled"
				:loading="pageSetting.btn.save.loading"
				@action="update"
			/>
		</template>
	</SOSlotModal>
</template>

<script>
import {mapGetters} from "vuex";
import {required} from "vuelidate/lib/validators"

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";
import SOButton from "@/so-components/global/ui/SOButton";
import ErrorMessage from "@/component-items/ErrorMessage";

export default {
	name: "CustomerModalUbahAgama",
	components: {
		SOSlotModal,
		SOInputRegular,
		SOInputSelect,
		SOButton,
		ErrorMessage,
	},
	computed: {
		...mapGetters("customerModule", {
			customer: "getDetailCustomer",
		}),
		...mapGetters("metaModule", {
			agama: "getAgama",
		})
	},
	data() {
		return {
			id: "modal-customer",
			customerTemp: {},
			pageSetting: {
				btn: {
					save: {
						disabled: false,
						loading: false,
						clicked: false
					}
				}
			}
		}
	},
	validations: {
		customerTemp: {
			agama: {
				required
			}
		}
	},
	mounted() {
		console.log(this.id)
		$("#" + this.id).modal("show");
		this.cloneVar()
	},
	methods: {
		cloneVar() {
			this.customerTemp = JSON.parse(JSON.stringify(this.customer))
		},
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		errorValidation() {
			this.$v.customerTemp.agama.$touch()
			return this.$v.customerTemp.agama.$invalid
		},
		async update() {
			if (this.errorValidation()) {
				this.pageSetting.btn.save.clicked = true
				this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
				return
			}
			this.pageSetting.btn.save.disabled = true
			this.pageSetting.btn.save.loading = true
			const res = await this.$store.dispatch("customerModule/updateCustomerAgama", this.customerTemp)
			this.pageSetting.btn.save.disabled = false
			this.pageSetting.btn.save.disabled = false
			if (res.success) {
				this.$toast.success(res.msg)
				this.close()
			} else {
				this.$toast.error(res.err)
			}
		},
		getAgama(id) {
			let index = this.agama.findIndex((a) => a.id === parseInt(id))
			this.customerTemp.agama = this.agama[index].id
		}
	}
}
</script>